// extracted by mini-css-extract-plugin
export default {"link":"styles_link__aW2Bj","buttonsHolder":"styles_buttonsHolder__ZY+on"};